export const platformBrand = {
  name: "ANL Platform",
  description: "Kurumsal Yönetim",
} as const;
